import { render, staticRenderFns } from "./NewRoleForm.vue?vue&type=template&id=4b7dffb5&scoped=true&"
import script from "./NewRoleForm.vue?vue&type=script&lang=js&"
export * from "./NewRoleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7dffb5",
  null
  
)

export default component.exports